<template>
  <div>
    <textarea
      class="form-control"
      :value="value"
      :placeholder="placeholder"
      :rows="rows"
      @input="onInput"
    ></textarea>
    <div class="d-flex justify-content-between align-items-center">
      <span
        v-if="error"
        class="text-danger small"
      >{{ error }}</span>
      <span
        v-else
        class="flex-grow-1"
      ></span>
      <span class="text-muted small">
        {{ currentLength }} characters
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTextareaCounter',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 4
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['input'],
  computed: {
    currentLength() {
      return this.value?.length || 0
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
